import React from 'react';
import {useParams} from 'react-router-dom';
import {Navigate} from 'react-router';
import {ROUTE_PATHS} from '@di-shared/routes';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import CapitalTermsDetail from '@di-shared/features/capital/CapitalTermsDetail';

function CapitalTermsDetailPage(): JSX.Element {
  const {t} = useInferableTranslation();
  const {termsId} = useParams();
  if (!termsId) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header right={<HeaderCloseButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30199')}</h1>
      </Header>
      <CapitalTermsDetail termsId={termsId} />
    </div>
  );
}

export default CapitalTermsDetailPage;
